const resultToggle = document.getElementsByClassName('ezpark-map-result-toggle')[0];
const results = document.getElementById('ezpark-map-results');

const toggleResults = function toggleResults() {
  if (resultToggle.getAttribute('aria-expanded') === 'true') {
    results.classList.add('ezpark-map-results--hidden');
    results.classList.remove('ezpark-map-results--visible');
    resultToggle.setAttribute('aria-expanded', 'false');
  } else {
    results.classList.add('ezpark-map-results--visible');
    results.classList.remove('ezpark-map-results--hidden');
    resultToggle.setAttribute('aria-expanded', 'true');
  }
};

if (resultToggle) {
  resultToggle.addEventListener('click', (event) => {
    event.preventDefault();
    toggleResults();
  });
}
